webpackJsonp([15],{

/***/ 104:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/pc_rss/img/qrcode_for_gh_3c0cf27cfbd1_430.17c1460.jpg";

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/pc_rss/img/logo.6c671ad.jpg";

/***/ }),

/***/ 112:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ArticleList"
  }, [_c('ul', [_c('li', {
    class: {
      act: _vm.$route.path == '/AboutUs'
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/AboutUs'
        });
      }
    }
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('li', {
    class: {
      act: _vm.$route.path == '/AdCooperation'
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/AdCooperation'
        });
      }
    }
  }, [_vm._v("广告合作")]), _vm._v(" "), _c('li', {
    class: {
      act: _vm.$route.path == '/EliteRecruitment'
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/EliteRecruitment'
        });
      }
    }
  }, [_vm._v("精英招聘")]), _vm._v(" "), _c('li', {
    class: {
      act: _vm.$route.path == '/Feedback'
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/Feedback'
        });
      }
    }
  }, [_vm._v("意见反馈")]), _vm._v(" "), _c('li', {
    class: {
      act: _vm.$route.path == '/TermsOfUse'
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/TermsOfUse'
        });
      }
    }
  }, [_vm._v("使用条款")]), _vm._v(" "), _c('li', {
    class: {
      act: _vm.$route.path == '/ContactUs'
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/ContactUs'
        });
      }
    }
  }, [_vm._v("联系我们")])])])
},staticRenderFns: []}

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show_ad) ? _c('div', {
    staticClass: "Ad"
  }, [(_vm.show_close) ? _c('i', {
    staticClass: "close el-icon-close",
    on: {
      "click": function($event) {
        _vm.closeAd();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ad && _vm.image) ? _c('a', {
    attrs: {
      "target": _vm.ad.target,
      "href": _vm.ad.href
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.image.http_path
    }
  })]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "label-box"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('label', {
    on: {
      "click": function($event) {
        _vm.show_weixin = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-weixin",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 关注我们")]), _vm._v(" "), _c('label', {
    staticClass: "o"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$config.apibase + '/index.php/api/upload/downloadShortcuts'
    }
  }, [_vm._v("保存到桌面")])])]), _vm._v(" "), _c('div', {
    staticClass: "icons"
  })]), _vm._v(" "), _c('div', {
    staticClass: "el-menu-box"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      "router": true,
      "mode": "horizontal"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/Newsflash"
    }
  }, [_vm._v("7x24h快讯")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/EconomicCalendar"
    }
  }, [_vm._v("财经日历")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/information_list/prediction"
    }
  }, [_vm._v("金汇预报")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/information_list/weekly"
    }
  }, [_vm._v("金汇周报")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/information_list/morningpaper"
    }
  }, [_vm._v("金汇早报")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/information_list/close"
    }
  }, [_vm._v("金汇内参")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/etfposition"
    }
  }, [_vm._v("ETF持仓")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/information_list/news"
    }
  }, [_vm._v("行业新闻")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/information_list/notice"
    }
  }, [_vm._v("金汇通知")])], 1)], 1), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "top": "3%",
      "title": "扫码关注公众号",
      "size": "tiny",
      "modal-append-to-body": false,
      "visible": _vm.show_weixin
    },
    on: {
      "update:visible": function($event) {
        _vm.show_weixin = $event
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(109)
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("扫码关注“每天都想看的资讯” ")])]), _vm._v(" "), _c('footer', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('div', {
    staticClass: "label-box"
  }, [_c('label', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/AboutUs'
        });
      }
    }
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('label', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/AdCooperation'
        });
      }
    }
  }, [_vm._v("广告合作")]), _vm._v(" "), _c('label', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/EliteRecruitment'
        });
      }
    }
  }, [_vm._v("精英招聘")]), _vm._v(" "), _c('label', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/Feedback'
        });
      }
    }
  }, [_vm._v("意见反馈")]), _vm._v(" "), _c('label', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/TermsOfUse'
        });
      }
    }
  }, [_vm._v("使用条款")]), _vm._v(" "), _c('label', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/ContactUs'
        });
      }
    }
  }, [_vm._v("联系我们")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "12px",
      "line-height": "1.5",
      "color": "#7d90a0"
    }
  }, [_vm._v("\n          金汇资讯 海南省瑞圣科技有限公司 版权所有 "), _c('a', {
    staticStyle: {
      "color": "#7d90a0"
    },
    attrs: {
      "target": "_blank",
      "href": "https://beian.miit.gov.cn/"
    }
  }, [_vm._v("琼ICP备2024029969号-1")]), _c('br'), _vm._v("\n          Copyright © 2012 - " + _vm._s(new Date().getFullYear()) + " jinhuizixun.com All Rights Reserved\n        ")])])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(110)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://user-v.rs-jinhuizixun.com/"
    }
  }, [_vm._v("用户中心")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('a', {
    attrs: {
      "href": "/#/Service/"
    }
  }, [_vm._v("私人订制")])])
}]}

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(115);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(42)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/EconomicCalendar',
    name: 'EconomicCalendar',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(42)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/Newsflash',
    name: 'Newsflash',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(129)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/information/:information_id',
    name: 'Information',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(126)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/information_simple/:information_id',
    name: 'InformationSimple',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(128)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/etfposition',
    name: 'EtfPosition',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(123)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/information_list/:column',
    name: 'InformationList',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(127)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/service',
    name: 'Service',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(130)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/AboutUs',
    name: 'AboutUs',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(119)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/AdCooperation',
    name: 'AdCooperation',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(120)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/EliteRecruitment',
    name: 'EliteRecruitment',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(122)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/Feedback',
    name: 'Feedback',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(124)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/TermsOfUse',
    name: 'TermsOfUse',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(131)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/ContactUs',
    name: 'ContactUs',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(121)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/Guide',
    name: 'Guide',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(125)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}));

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(106)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(114),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(113),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6fa49a5b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(104)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(112),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23dede2c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      user: null,
      show_weixin: false,
      is_login: true,
      activeIndex: ''
    };
  },
  created: function created() {
    this.setNav(this.$route.path);
    this.get_user();
  },

  watch: {
    '$route.path': {
      handler: function handler(val) {
        this.setNav(val);
        this.get_user();
      }
    }
  },
  methods: {
    get_user: function get_user() {
      var self = this;
      this.$http.get(this.$config.apibase + '/index.php/api/user/get_guest.html').then(function (response) {
        if (response.data.state == 0) {
          self.user = response.data.user;
        }
      });
    },
    setNav: function setNav(name) {
      this.activeIndex = name;
    }
  }
});

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      image: null,
      show_ad: true,
      ad: null
    };
  },

  props: ['show_close', 'position', 'path'],
  created: function created() {
    this.get_ad();
    this.show_ad = sessionStorage[this.path + '' + this.position] === undefined ? true : JSON.parse(sessionStorage[this.path + '' + this.position]);
  },

  methods: {
    closeAd: function closeAd() {
      sessionStorage[this.path + '' + this.position] = false;
      this.show_ad = false;
    },
    get_image: function get_image() {
      var self = this;
      self.$http.post(self.$config.apibase + '/index.php/api/upload/get_image.html', { image_id: self.ad.image }).then(function (response) {
        if (response.data.state == 0) {
          self.image = response.data.image;
          self.close = false;
        }
      });
    },
    get_ad: function get_ad() {
      var self = this;
      self.$http.post(self.$config.apibase + '/index.php/api/ad/get_ad.html', { path: this.path || this.$route.path, position: this.position }).then(function (res) {
        if (res.data.state != 0 || !res.data.ad) {
          return;
        }
        self.ad = res.data.ad;
        self.get_image();
      });
    }
  }
});

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  props: ['article'],
  created: function created() {},

  methods: {}
});

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_theme_default__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_theme_default___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_theme_default__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_font_awesome_css__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_main_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_css_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_animate_css_animate_min_css__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_animate_css_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_animate_css_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Ad__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Ad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_common_Ad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_ArticleList__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_ArticleList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_common_ArticleList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router__ = __webpack_require__(31);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$config = { interfacebase: { 'etfposition': 'http://' + window.location.hostname + ':3032', 'marketinfo': 'http://' + window.location.hostname + ':3022', 'calendar': 'https://rili-d.jin10.com/open.php' }, apibase: window.location.protocol + '//' + window.location.hostname };

__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Ad', __WEBPACK_IMPORTED_MODULE_9__components_common_Ad___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ArticleList', __WEBPACK_IMPORTED_MODULE_10__components_common_ArticleList___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('amount', function (value) {
  if (typeof value !== 'number') {
    value = Number(value);
  }
  return value.toFixed(2);
});
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_11__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_8__App___default.a }
});

/***/ })

},[85]);


// WEBPACK FOOTER //
// static/pc_rss/js/app.6cb6f6b8145c72010589.js